import { trailingSlash } from "./helpers";
import _ from "lodash";

export default {
  created: function() {
    // this.initSemestersList();
  },
  data() {
    return {
      semesters: [],
    };
  },
  computed: {
    semestersURL() {
      return (
        trailingSlash(process.env.VUE_APP_PROGRAMS_URL) +
        "api/terms/" +
        this.value.programSelection.location.value
      );
    },
  },
  methods: {
    initSemestersList() {
      fetch(this.semestersURL)
        .then(response => response.json())
        .then(data => {
          this.semesters = Object.values(data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    /**
     * Triggered when the search text changes on vSelect component for semesters list
     *
     * @param search  {String}    Current search text
     * @param loading {Function}  Toggle loading class
     */
    searchSemesters(search, loading) {
      console.log("search", search);
      console.log("loading", loading);
      loading(true);
      this.throttledSearchSemesters(search, loading, this);
    },
    throttledSearchSemesters: _.debounce((search, loading, vm) => {
      fetch(vm.semestersURL + "?search=" + encodeURIComponent(search))
        .then(response => response.json())
        .then(data => {
          vm.semesters = Object.values(data);
          loading(false);
        })
        .catch(() => {
          loading(false);
        });
    }, 250),
  },
};